import { render, staticRenderFns } from "./EHSTable.vue?vue&type=template&id=b5cfac7e&scoped=true&"
import script from "./EHSTable.vue?vue&type=script&lang=js&"
export * from "./EHSTable.vue?vue&type=script&lang=js&"
import style0 from "./EHSTable.vue?vue&type=style&index=0&id=b5cfac7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cfac7e",
  null
  
)

export default component.exports